@if (loading()) {
    <div class="senddokument-spinner-wrapper">
        <span class="hb-spinner" role="alert">
          <span class="hb-screenreader-only" translate>Vennligst vent, siden laster.</span>
        </span>
    </div>
}
@if (myUuid() != null && myUuid() != "") {
    @if (skjemaRenderState$.value == "oppsummering") {
        <h1 class="hb-h1 hb-text--3xl hb-mt--2xl hb-mb--3xl" #heading tabindex="-1" translate>Se over før du sender inn</h1>
    }
    <rzrforms
        [skjemaid]="myUuid()"
        [skjemaDef]="formDef"
        (formEvents)="handleEvent($event)"
        (formState)="skjemaRenderState($event)"
        [serverPersistence]="true"
    />
}
